export const getInlineOrBlockClassName = (inline: boolean) => (inline ? 'inline' : 'block');
